import React from "react";

const SettingsIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.25 5.5H18.25M14.25 3.5V7.5M14.25 5.5H3.25M7.25 12.5H3.25M11.25 10.5V14.5M22.25 12.5H11.25M21.25 19.5H18.25M14.25 17.5V21.5M14.25 19.5H3.25"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SettingsIcon;
